import type { Ref } from 'vue'

export const useModals = () => {
  // Keeps track of the state of the modal
  const isModalOpen: Ref<boolean> = ref(false)

  /**
   * Opens the modal
   */
  function openModal() {
    return (isModalOpen.value = true)
  }

  /**
   * Closes the modal
   */
  function closeModal() {
    return (isModalOpen.value = false)
  }

  /**
   * Toggles the modal
   */
  function toggleModal() {
    return (isModalOpen.value = !isModalOpen.value)
  }

  return {
    isModalOpen,
    openModal,
    closeModal,
    toggleModal,
  }
}
